/**
 * External dependencies
 */
import inherits from 'inherits';

export default class PaymentMethod {
    
    constructor(cscom) {
        if (!(this instanceof PaymentMethod)) {
            return new PaymentMethod(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/payment-methods/list', null, data);
    }

    createUsingToken(token) {
        return this.cscom.req.post('/customer-site-api/payment-methods/createUsingToken', null, { token });
    }

    removePaymentMethod(id) {
        return this.cscom.req.post('/customer-site-api/payment-methods/removePaymentMethod', null, { id })
    }

}
